module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"af_footer_1":"運営会社について","af_footer_2":"公式Facebookページ"},"en":{"af_footer_1":"about us","af_footer_2":"official Facebook page"},"ko":{"af_footer_1":"우리의 관하여","af_footer_2":"공식 페이스북 페이지"},"zh-cn":{"af_footer_1":"关于我们","af_footer_2":"官方facebook网址"},"zh-tw":{"af_footer_1":"關於我們","af_footer_2":"官方facebook網址"}}')
  delete Component.options._Ctor
}
